
enum EnumTheme {
  Light = 1,
  Dark = 2,
}

enum EnumFeedback {
  Success = "success",
  Error = "error",
  Info = "info",
  Warning = "warning"
}

enum EnumResponse {
  Success = 200,
  Error = 500,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  None = 0,
}

enum EnumLayout {
  Default = "default",
  Page = "page",
  Project = "project",
}

enum EnumValidation {
  Required = "required",
  IsGraterThan = "isGraterThan",
  IsLessThan = "isLessThan",
  IsEquals = "isEquals",
  MinLength = "minLength",
  Function = "function",
  Regex = "regex"
}

enum EnumFlow {
  Profile = "profile",
  Onboarding = "onboarding",
  Contributor = "contributor",
  Potluck = "potluck"
}

enum EnumShare {
  Invite = "invite",
  Results = "results"
}

export {
  EnumShare,
  EnumFlow,
  EnumTheme,
  EnumLayout,
  EnumResponse,
  EnumFeedback,
  EnumValidation
}